import React, { useState, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import {
  resetLinkedList,
  getLabelAndValue,
  resetList,
} from "../../CommonFuntion/SchemaValidation";
import { titleCase } from "../../CommonFuntion/SchemaValidation";

const CssSelectField = styled(Select)({
  ".MuiSelect-select": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
  "& div.MuiSelect-nativeInput": {
    fontSize: 12,
  },
});

export function ELLDropDown(props) {
  const {
    name,
    label,
    options,
    value,
    tagName,
    prefix,
    validation,
    schemaPageId,
    schemaResult,
    schemaItem,
    childLists,
    setChildOpt,
    childPageId,
    childItemId,
    formData,
    mandatoryByLabelName,
    disableByLabelName,
    handleResetELCList,
    handleELLValue,
    childOpt,
    setLLIValue,
    LLIValue,
    handleELLVSchemaItem,
  } = props;
  const [options2, setOptions2] = useState(options);
  const { setFieldValue, values } = useFormikContext();
  useEffect(() => {
    if (formData[name] && formData[name] !== null && formData[name] !== "") {
      if (prefix === "ELL") {
        const optionValue = options.find(
          (x) => x.label === formData[name]
        )?.value;
        // merge initial ELL value into object by schemaItem
        handleELLValue((prev) => ({ ...(prev || {}), [schemaItem]: optionValue }));
        handleELLVSchemaItem(schemaItem);
      }
    }
  }, [formData]);

  const id = `${tagName}-input`;
  const handleChange = (e, selected) => {
    const { value } = e.target;
    const option = options.find((x) => x.label === e.target.value);
    if (option) {
      setFieldValue([name], option?.label);
    } else {
      setFieldValue([name], "");
    }
    resetLinkedList(
      schemaResult,
      schemaPageId,
      schemaItem,
      values,
      setFieldValue
    );
    handleResetELCList(true);
    handleELLValue((prev) => ({ ...(prev || {}), [schemaItem]: option?.value }));
    handleELLVSchemaItem(schemaItem);
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" id={id}>
              {titleCase(label.replace("_", " "))}

              {(validation?.mandatory ||
                (validation?.mandatoryByLabelName &&
                  validation?.mandatoryByLabelName ===
                    mandatoryByLabelName)) && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl variant="standard" aria-labelledby={id}>
            <CssSelectField
              labelId={label}
              id={tagName}
              name={name}
              key={name}
              tagname={tagName}
              fieldname={name}
              prefix={prefix}
              className="control-width-font"
              style={{
                fontSize: "12px",
              }}
              onChange={handleChange}
              label={titleCase(label.split(" ")[0].replace("_", " "))}
              value={values[name] || ""}
              //value={getLabelAndValue(values[name])[0] || ""}
              disabled={
                validation?.disableByLabelName &&
                validation?.disableByLabelName === disableByLabelName
              }
            >
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                value=""
              ></MenuItem>
              {options2.map((optn, index) => (
                <MenuItem
                  style={{
                    fontSize: "12px",
                  }}
                  key={index}
                  value={optn.label}
                  label={optn.label || optn.value}
                >
                  {optn.label}
                </MenuItem>
              ))}
            </CssSelectField>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
    </>
  );
}
